"use client";

import Script from "next/script";

/*
 * strategy is 'lazyOnload', NOT 'worker'. next/script's worker strategy is a silent
 * no-op in the App Router: its loader effect only handles afterInteractive and
 * lazyOnload, and the worker branch needs the Pages-Router HeadManagerContext
 * (updateScripts/getIsSsr), which app/ never provides. Nothing is injected, nothing
 * is logged — the tag simply never runs. This script was dead in production from
 * #323 (Oct 2024) until it was switched back. Partytown being installed and
 * nextScriptWorkers being on does not change that. Do not set it back to 'worker'.
 */
export default function Clarity() {
    return (
        <Script id={"clarity-script"} strategy={'lazyOnload'}>
            {`
            (function(c,l,a,r,i,t,y){ c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)}; t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i; y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y); })(window, document, "clarity", "script", "nxj2420qsh"); 
            `}
        </Script>
    );
}